import { setProps } from '../props';
import fetchSupplier from '../Services/fetchSupplier';

export default (props) => async (dispatch) => {
  setProps(props);
  dispatch(fetchSupplier());
}
